import { render, staticRenderFns } from "./QuestionTypeMissWord.vue?vue&type=template&id=53403513"
import script from "./QuestionTypeMissWord.vue?vue&type=script&lang=js"
export * from "./QuestionTypeMissWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports